import { LoadingIndicator } from '@w/ui/components/loading-indicator'

export function LoadingSpinner() {
  return (
    <div
      className="flex h-screen items-center justify-center"
      data-testid="flashcards-app-loading"
    >
      <LoadingIndicator />
    </div>
  )
}
